import PropTypes from 'prop-types';
import QRCode from 'qrcode';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useModal from 'hooks/useModal';
import { getQuestionInfo } from 'questions';

import CourseShare from './CourseShare';

const CourseShareContainer = ({ course, ...props }) => {
  const { t } = useTranslation();
  const { isModalOpen, handleModalOpen, handleModalClose } = useModal(false);
  const [isDisplayed, setIsDisplayed] = useState(true);
  const canvasRef = useCallback(
    (element) => {
      if (element) {
        QRCode.toCanvas(
          element,
          `${process.env.REACT_APP_WEB_URL}/join/${course.accessCode}?from=2`,
          (err) => {
            if (err) {
              setIsDisplayed(false);
            }
          },
        );
      }
    },
    [course],
  );
  const isExpertLinkDisplayed =
    course.questions.some((question) => {
      const questionInfo = getQuestionInfo(question.type);
      return questionInfo.expert;
    }) ||
    course.chapters.some((chapter) =>
      chapter.questions.some((question) => {
        const questionInfo = getQuestionInfo(question.type);
        return questionInfo.expert;
      }),
    );
  return (
    <CourseShare
      canvasRef={canvasRef}
      course={course}
      handleModalClose={handleModalClose}
      handleModalOpen={handleModalOpen}
      isDisplayed={isDisplayed}
      isExpertLinkDisplayed={isExpertLinkDisplayed}
      isModalOpen={isModalOpen}
      t={t}
      {...props}
    />
  );
};

CourseShareContainer.propTypes = {
  course: PropTypes.object.isRequired,
};

export default CourseShareContainer;
